import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnChanges,
} from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import {
  BehaviorInputData,
  FidelityReviewSection,
  FormEventEmit,
} from '../../../fidelity.interface';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AuthService } from '../../../../../core/services/auth.service';
import { userDetailModel } from '../../../../organizations/organization.interface';
import { InsightTerm, ReviewStatus } from '../../../fidelity.enums';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-correction-needed-form',
  standalone: true,
  imports: [
    NzFormModule,
    SvgIconComponent,
    NzInputModule,
    NzCheckboxModule,
    NzToolTipModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  templateUrl: './correction-needed-form.component.html',
})
export class CorrectionNeededFormComponent implements OnInit, OnChanges {
  @Input() fidelityData: BehaviorInputData | null = null;
  @Output() formValueChange = new EventEmitter<FormEventEmit>();
  @Input() fidelityFormData: FidelityReviewSection | null = null;
  reviewForm: FormGroup;
  reviewStatus = ReviewStatus;
  private userId = 0;
  userData: userDetailModel | null = null;
  constructor(
    private readonly fb: FormBuilder,
    private readonly authService: AuthService
  ) {
    this.reviewForm = this.fb.group({
      id: [0],
      reviewType: [89],
      caseBehaviourId: [0],
      reviewScoreTypeId: [null, Validators.required],
      requestChanges: [false],
      adminNotes: [''],
      userNotes: ['', [Validators.required, Validators.maxLength(5000)]],
      reviewStatusId: [1],
      dateModifiedByAdmin: [new Date()],
      reviewedByAdminUserId: [null],
      changesApplied: [false],
    });
  }

  ngOnInit(): void {
    this.reviewForm.valueChanges.subscribe(val => {
      const payload: FormEventEmit = {
        formValue: val,
        isFormValid: this.reviewForm.valid,
      };
      this.formValueChange.emit(payload);
    });
  }

  ngOnChanges(): void {
    this.authService.userData$.subscribe(user => {
      this.userData = user;
      if (this.userData?.isSuperAdmin) {
        this.reviewForm.get('userNotes')?.disable();
      }
      this.userId = user?.id || 0;
      this.reviewForm.patchValue({ reviewedByAdminUserId: this.userId });
    });
    if (this.fidelityFormData) {
      this.patchForm(this.fidelityFormData);
    }
  }
  patchForm(data: FidelityReviewSection): void {
    this.reviewForm.patchValue({
      id: data?.id || 0,
      reviewType:
        data?.reviewScoreType?.reviewTypeId ||
        (this.fidelityData?.selectedTab === undefined
          ? null
          : InsightTerm[
              this.fidelityData.selectedTab as keyof typeof InsightTerm
            ]),
      caseBehaviourId: data?.caseBehaviourId || 0,
      reviewScoreTypeId: data?.reviewScoreType?.id || null,
      requestChanges: data?.requestChanges || false,
      changesApplied:
        data?.reviewStatusId === this.reviewStatus['Changes Received'] || false,
      adminNotes: data?.adminNotes || '',
      userNotes: data?.userNotes || '',
      reviewStatusId: data?.reviewStatusId || 93,
      dateModifiedByAdmin: data?.dateModifiedByAdmin || new Date(),
      reviewedByAdminUserId: this.userId,
    });
  }

  onCheckBoxChange(event: boolean): void {
    if (event) {
      this.reviewForm
        .get('reviewStatusId')
        ?.setValue(this.reviewStatus['Changes Received']);
    } else {
      this.reviewForm
        .get('reviewStatusId')
        ?.setValue(this.reviewStatus['Changes Requested']);
    }
  }
}
